import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'auftrag-dateien-komponente',
    template: `
        <div *ngIf="auftrag.Anlagen && auftrag.Anlagen.length > 0">
          <div class="section ion-activatable" style="padding-bottom: 0;">
            <app-auftrag-dateien [auftrag]="auftrag"></app-auftrag-dateien>
          </div>

          <ion-item-divider> </ion-item-divider>
        </div>
    `,
    styles: [`
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragDateienComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
